declare let gtag;

export default () => {
  return () => {
    gtag('event', 'conversion', { send_to: 'AW-588882135/eHPGCOCJ94sCENfB5pgC' });
  };
};
